import { get as _get } from 'lodash';
import {
  createMockApiResponse,
  getMockClaimType,
  getMockValidateSessionData,
  isMockModeEnabled,
} from '../utils/mockDataHelper';
import { getContextRouterURL, getRegion } from './urlResolver';

export async function validateSession(urlId: string, authId: string) {
  // If in mock mode, return mock session data
  if (isMockModeEnabled()) {
    const claimType = getMockClaimType();
    console.log('🔧 Mock Mode: Using mock context-router session');
    console.log('🔍 validateContextRouterApi - Resolved claim type:', claimType);

    // Simulate network delay
    await new Promise((resolve) => setTimeout(resolve, 300));

    const mockData = await getMockValidateSessionData(claimType);
    return createMockApiResponse(mockData);
  }

  // Otherwise, use real API
  try {
    const region = await getRegion();
    const url = getContextRouterURL(region);

    const headers = {
      urlid: urlId,
      Authorization: 'Bearer ' + authId,
    };

    const response = await fetch(url, {
      headers: headers,
      method: 'GET',
    });
    const responseData = await response.json();
    const { statusCode } = responseData;
    const { error } = responseData;
    const { message } = responseData;
    if (_get(responseData, 'status.statusCode', '') >= 200) {
      return responseData;
    } else {
      return { error, statusCode, message };
    }
  } catch (error) {
    console.log('validateSession:error', error);
    return error;
  }
}
